import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Capacitor } from '@capacitor/core';
import { SegmentCustomEvent } from '@ionic/core';
import { asyncScheduler, Subscription } from 'rxjs';

export interface SegmentItem {
  id: number;
  title: string;
  subtitle: string;
  active: boolean;
  icon?: string;
  color?: string;
}

@Component({
  selector: 'getm-filter-pill',
  templateUrl: './filter-pill.component.html',
  styleUrls: ['./filter-pill.component.scss']
})
export class FilterPillComponent implements OnInit, OnDestroy {

  @ViewChild('segmentPills', { read: ElementRef }) segment!: ElementRef<HTMLElement>;

  @Input() segments: SegmentItem[] = [];
  @Input() set selected(value: number) {
    this.newValue = value;
  }
  @Input() colorSegment: string = 'getm-background-light-blue';

  @Output() tabChange = new EventEmitter<number>();

  public newValue: number = 0;
  public isDesktop: boolean = false;

  private mainSubscription: Subscription = new Subscription();

  constructor() { }

  ngOnInit() {
    this.isDesktop = !Capacitor.isNativePlatform();
  }

  ngOnDestroy() {
    this.mainSubscription.unsubscribe();
  }

  public onSegmentChange = (event: SegmentCustomEvent): void => {
    this.newValue = event.detail.value as number;
    this.tabChange.emit(this.newValue);
  };

  public onPill = (index: number) => {
    this.mainSubscription.add(asyncScheduler.schedule(() => {
      const container = this.segment?.nativeElement ?? {} as HTMLElement;
      const buttons = container.querySelectorAll('ion-segment-button');
      const btn = buttons[index];
      if (!btn) return;
      const target = btn.offsetLeft - (container.clientWidth - btn.offsetWidth) / 2;
      container.scrollTo({ left: Math.max(0, target), behavior: 'smooth' });
    }, 400));
  }

}
